import { Component } from "react";

class PriceDetails extends Component {
  render() {
    return (
      <section className="car__price_detail px-3">
        <div className="d-flex justify-content-between car__price_Row pt-2">
          <div className="d-flex align-items-center">
            <input
              type="number"
              defaultValue="03"
              className="car__nbr_prsn mr-2"
            />
            <span>Personnes</span>
          </div>
          <div className="d-flex">
            <span>500x2= 1 000</span>
          </div>
        </div>

        <div className="d-flex justify-content-between car__price_Row pt-2">
          <div className="d-flex  align-items-center">
            <input type="checkbox" defaultChecked className="mr-2" />
            <span>course Privée</span>
          </div>
          <div className="d-flex">
            <span>3500</span>
          </div>
        </div>
        <div className="d-flex justify-content-end car__price_Row">
          <div className="d-flex flex-column py-2">
            <div className="d-flex justify-content-between">
              <div className="d-flex   align-items-center">
                <input type="checkbox" defaultChecked className="mr-2"/>
                <span className="mr-3 car__option_pric">Siége Bébé</span>
              </div>
              <div>
                <span>+200 DZD</span>
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div className="d-flex  align-items-center">
                <input type="checkbox" defaultChecked className="mr-2"/>
                <span className="mr-3 car__option_pric">Suppl.Bagage</span>
              </div>
              <div>
                <span>+150 DZD</span>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between py-2">
          <div className="d-flex">
            <span>Total</span>
          </div>
          <div className="d-flex">
            <span className="total">3850 DZD</span>
          </div>
        </div>

        <div className="d-flex justify-content-end car__price_Row py-2">
          <div className="d-flex align-items-center">
          <input type="checkbox" defaultChecked className="mr-2"/>
            <span className="mr-3 total-price">Paiment Sécurisé via Ghurfaty</span>
          </div>
          <div className="d-flex">
            <span className="car__perc">+10%</span>
          </div>
        </div>

        <div className="d-flex justify-content-between py-2">
          <div className="d-flex  align-items-center">
            <span className="total-price font-weight-bold">Total TTC</span>
          </div>
          <div className="d-flex">
            <span className="total-price bold-price">4235 DZD</span>
          </div>
        </div>

      </section>
    );
  }
}

export default PriceDetails;
